module.exports = __webpack_public_path__ + "ptc_momoro_O1.56639dab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_O1.jpg
// module id = CxRs
// module chunks = 0